// extracted by mini-css-extract-plugin
export default {"root":"lZA8QjCj0VcUc9m8zare","placeHolderShimmer":"fLGvdZsbOwQbVOdZAKLA"};